import Vue from 'vue';
import moment from 'moment';

export default {
  state: {
    members: {},
  },
  mutations: {
    addActivities(state, payload) {
      if (!state.members[payload.memberId]) {
        Vue.set(state.members, payload.memberId, []);
      }
      state.members[payload.memberId].push(...payload.activities);
    },
    clearActivities(state, payload) {
      if (payload && payload.memberId) {
        if (state.members[payload.memberId]) {
          state.members[payload.memberId].length = 0;
        }
      } else {
        // remove everything
        state.members = {};
      }
    },
  },
  getters: {
    activitiesByMemberId: state => (memberId) => {
      if (!state.members[memberId]) {
        return [];
      }

      return state.members[memberId];
    },
    activityByMemberIdAndActivityId: state => (memberId, activityId) => {
      if (!state.members[memberId]) {
        return null;
      }

      return state.members[memberId]
        .find(activity => activity.activity_id === activityId);
    },
    activitiesByMemberIdAndDate: state => (memberId, momentDate) => {
      if (!state.members[memberId]) {
        return [];
      }

      const format = 'YYYY-MM-DD';

      return state.members[memberId]
        .filter(
          activity => moment(activity.local_start_time).format(format)
            === momentDate.format(format),
        );
    },
  },
  actions: {
    clearActivities(context, payload) {
      context.commit('clearActivities', payload);
    },
  },
};
